export const ENDPOINT = process.env.NODE_ENV === 'development' ? "http://127.0.0.1:3333" : "https://api.ihore.id";

export const SOCK_POINT = process.env.NODE_ENV === 'development' ? "http://127.0.0.1:5200" : (process.env?.REACT_APP_WS_URL || "https://ws.ihore.id");


export const DEFAULT_FULL_ACCESS = 3
export const DEFAULT_WRITE_ACCESS = 2
export const DEFAULT_READ_ACCESS = 1


